import { api } from 'redux/api/index.api';

export const subscriptionsApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchCurrentOffer: builder.query({
      query: ({ organizationId }) => ({
        url: `subscriptions/${organizationId}/current`,
        method: 'GET',
      }),
    }),
    fetchAvailableOffers: builder.query({
      query: ({ organizationId }) => ({
        url: `offers/${organizationId}/available`,
        method: 'GET',
      }),
    }),
    cancelPlan: builder.mutation({
      query: ({ organizationId }) => ({
        url: `orders/${organizationId}/cancel`,
        method: 'POST',
      }),
    }),
    managePaymentMethod: builder.mutation({
      query: ({ organizationId, redirect }) => ({
        url: `subscriptions/${organizationId}/manage`,
        method: 'POST',
        body: { redirect },
        responseHandler: response => response.json(),
      }),
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFetchCurrentOfferQuery,
  useLazyFetchCurrentOfferQuery,
  useFetchAvailableOffersQuery,
  useLazyFetchAvailableOffersQuery,
  useCancelPlanMutation,
  useManagePaymentMethodMutation,
} = subscriptionsApi;
